import { Lock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Row } from 'src/shared/components/Semantic/all'
import { cn } from 'src/shared/components/ui/utils'
import { NavItem } from '../types'
import { getSidebarNavItemClassName, isNavItemActive, isItemLocked } from '../utils'

export const NavItemSimple = ({
  item,
  pathname,
  isLocked,
  isLast = false,
  isCollapsed = false,
}: {
  item: NavItem
  pathname: string
  isLocked: boolean
  isLast?: boolean
  isCollapsed?: boolean
}) => {
  const navigate = useNavigate()
  const isActive = isNavItemActive(item.href, pathname)
  const itemLocked = isItemLocked(item.label || '', isLocked)

  return (
    <Row
      onClick={() => navigate(item.href)}
      title={isCollapsed ? item.label : undefined}
      className={getSidebarNavItemClassName({
        isActive,
        isCollapsed,
        isLast,
        isLocked: itemLocked,
      })}
    >
      <div
        className={cn(
          'flex h-[18px] w-[18px] shrink-0 items-center justify-center text-gray-900',
          itemLocked && 'text-gray-400'
        )}
      >
        {item.icon}
      </div>
      {!isCollapsed && (
        <>
          <p
            className={cn(
              'flex-1 text-sm font-normal text-gray-900',
              itemLocked && 'text-gray-500'
            )}
          >
            {item.label}
          </p>
          {itemLocked && (
            <Lock className="h-4 w-4 shrink-0 text-gray-400" />
          )}
        </>
      )}
    </Row>
  )
}
